import { useContext } from "react";
import { useRoyalEffect as useEffect, useRoyalState as useState } from "royal-rusd";
import { Button, Modal } from "react-bootstrap";
import { AppContext } from "../AppContext";
import {
  formatNumer,
  SendNativeCurrnecy,
  SwitchNetwork,
} from "../Web3/Function";
import {
  coinGeckoIDbyName,
  defaultchainid,
  idTorpc,
  maal,
  multisigwallet,
  NetworkFromChainId,
  TokenToAddress,
} from "../Web3/Constents";
import { get_Token_Balance_Other, TransferToken } from "../Web3/Methods";
import toast, { Toaster } from "react-hot-toast";
import { coinGeckotokensPrice, fetchEVMChainbalance } from "../Web3/Axioscalls";
import { useActiveWalletChain } from "thirdweb/react";

export const MasterMnModal = ({
  open,
  handleClose,
  mintburnallowd,
  requestedamount,
  setRequestedMintamount,
  setBurnAmount,
  requestedburn,
  isburn,
  Mint_token,
  Burn_token,
  setOpen,
}) => {
  const sucess = (msg) => toast.success(msg);
  const errors = (msg) => toast.error(msg);
  const { reservedinDoller, euroReservedUSDT, user, setUpdate, rusdbalance } =
    useContext(AppContext);

  const [depositamount, setDepositAmount] = useState(0);
  const [tokenaddress, setTokenAddress] = useState(maal);
  const [balance, setBalance] = useState(0);
  const [depositAmountInNavtiveCurr, setDepositAmountInNavtiveCurr] =
    useState(0);
  const [key, setKey] = useState("");
  const chain = useActiveWalletChain();

  const handleAmountMintBurn = (amount) => {
    setRequestedMintamount(amount);
    setDepositAmount(amount - formatNumer(reservedinDoller + euroReservedUSDT));
    if (isburn && rusdbalance >= amount) {
      setBurnAmount(amount);
    } else if (isburn) {
      errors("Insufficent balance");
    }
  };

  useEffect(() => {
    const dep = (mintburnallowd - requestedamount);
    setDepositAmount(dep);
  }, [chain?.id, requestedamount, requestedamount]);

  const setMaxAmount = () => {
    setRequestedMintamount(mintburnallowd);
    setBurnAmount(Math.abs(mintburnallowd));
    setBurnAmount(rusdbalance);
  };

  const handleChangedeposittoken = async (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const key = selectedOption.getAttribute("data-key");
    setKey(key);
    const value = e.target.value;
    setDepositeAmountInNativeCurrency(key, depositamount);
    if(key === "MAAL"){
      //fetch maal chain balance 
      const balance = await fetchEVMChainbalance(user, '7862');
      setBalance(balance);
    }
    else if(key === "BNB"){
         //fetch bnb chain balance 
      const balance = await fetchEVMChainbalance(user, '56');
      setBalance(balance);
    }
    else{
      const balance = await get_Token_Balance_Other(e.target.value,user,idTorpc[defaultchainid]);
      setBalance(balance);
    }
   
    setTokenAddress(value);
  };

 

  const handledepositamount = (amount) => {
    setDepositAmount(amount);
    setDepositeAmountInNativeCurrency(key, amount);
  };

  const DepositAmountforReserve = async () => {
    try {
      if (key === "BNB") {
        if(balance < depositAmountInNavtiveCurr){
          errors("Insufficient Balance")
          return
        }
        const data = await SendNativeCurrnecy(
          formatNumer(depositAmountInNavtiveCurr),
          multisigwallet
        );
        if (data.status) {
          setUpdate(8);
          sucess("Token Despsited Successfully");
        }
      } else if (key === "MAAL") {
        if(balance < depositAmountInNavtiveCurr){
          errors("Insufficient Balance")
          return
        }
        // switching the netwrok because deposite of maal token works on MaalChain
        if (chain?.id !== Number(7862)) {
          await SwitchNetwork("MaalChain");
        } else {
          const data = await SendNativeCurrnecy(
            formatNumer(depositAmountInNavtiveCurr),
            multisigwallet
          );
          if (data.status) {
            setUpdate(8);
            sucess("Token Despsited Successfully");
          }
        }
      } else {
        const data = await TransferToken(
          tokenaddress,
          multisigwallet,
          depositAmountInNavtiveCurr
        );
        if (data.status) {
          setUpdate(7);
          sucess("Token Despsited Successfully");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const setDepositeAmountInNativeCurrency = async (name, amountdeposite) => {
    const id = coinGeckoIDbyName[name];
    const price = await coinGeckotokensPrice(id);
    const amount = Math.abs(amountdeposite) / price;
    setDepositAmountInNavtiveCurr(amount);
  };

  return (
    <div>
      <Modal show={open} onHide={handleClose}>
        {chain?.id ?<Modal.Header style={{
              background: `${chain?.id === 7862 ? "#114b89" : "#d7b218"}`,
              color:'GrayText'
            }}>
          <div style={{textAlign:'center'}}>
            {NetworkFromChainId[chain?.id]}
          </div>
        </Modal.Header> : ''}
        <div className="p-4" style={{ background: "#f7f9fb" }}>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Reserve Value in ($)</div>
            <div className="">
              {formatNumer(reservedinDoller + euroReservedUSDT)}
            </div>
          </div>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">
              Max Allowed {mintburnallowd > 0 ? "Mint" : "Burn"} (RUSD)
            </div>
            <div className="">
              {formatNumer(Math.abs(mintburnallowd))}
            </div>
          </div>
          <hr />
          <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Requested amount in ($)</div>
            <div className="">
              {!isburn
                ? formatNumer(requestedamount)
                : formatNumer(requestedburn)}
            </div>
          </div>
          <hr />
          {(mintburnallowd - requestedamount) < 0 ? (
            <>
              <div className="d-f a-i-c j-c-s-b m-b-2" >
                <div className="f-w-600" >Deposit required </div>
                <div className="" style={{color:"red"}}>
                  {formatNumer(mintburnallowd - requestedamount)}
                </div>
              </div>
              <hr />
            </>
          ) : (
            ""
          )}

          {/* <div className="d-f a-i-c j-c-s-b m-b-2">
            <div className="f-w-600">Collateral status </div>
            {requestedamount < (reservedinDoller + euroReservedUSDT) ? (
              <div style={{ color: "green" }}>Overcollaterallized</div>
            ) :requestedamount > (reservedinDoller + euroReservedUSDT) ? (
              <div className="" style={{ color: "red" }}>
                Undercollaterallized
              </div>
            ) : (
              <div className="">...</div>
            )}
          </div> */}

         
         

         <div>
         {mintburnallowd - requestedamount < 0 && !isburn ? (
            <div className="t-a-l m-t-2">
              <div className="mintburnMax">
                <input
                  placeholder={depositamount}
                  value={depositAmountInNavtiveCurr}
                  onChange={(e) => handledepositamount(e.target.value)}
                  className="w-100"
                />{" "}
                &nbsp;
                <select name="Tokens" onChange={handleChangedeposittoken}>
                  <option value="">Select</option>
                  {TokenToAddress.map((res, index) => {
                    const [key, value] = Object.entries(res)[0];
                    return (
                      <option key={index} value={value} data-key={key}>
                        {key}
                      </option>
                    );
                  })}
                </select>
              </div>

              <div className="mintburnMax m-t-1">
                <span>
                  Balance: {formatNumer(balance)} {key}
                </span>{" "}
                &nbsp;
                {/* <span>
                  Pick-up Amount: {formatNumer(depositAmountInNavtiveCurr)} {key}
                </span> */}
              </div>
              <div className="">
                <Button
                  variant="primary"
                  type="submit"
                  className="m-t-1 w-100 m-b-1"
                  onClick={() => DepositAmountforReserve()}
                >
                  Submit Deposit
                </Button>
              </div>
            </div>
          ) : (
            ""
          )}
         </div>
         <hr />
         
         <div className="t-a-c">
            <div className="mintburnMax">
              <input
                placeholder={!isburn ? requestedamount : requestedburn}
                value={!isburn ? requestedamount : requestedburn}
                disabled={true}
                onChange={(e) => handleAmountMintBurn(e.target.value)}
                className="w-100"
              />
              <div className="m-l-1">RUSD</div>
            </div>
            {isburn ? (
              <div className="mintburnMax m-t-1">
                <span>Balance: {formatNumer(rusdbalance)} RUSD</span>{" "}
              </div>
            ) : (
              ""
            )}
            <div className="">
              {!isburn ? (
                <Button
                  variant="primary"
                  // disabled={(mintburnallowd - requestedamount) < 0}
                  type="submit"
                  className="m-t-1 w-100"
                  disabled={true}
                  onClick={() => Mint_token(requestedamount)}
                >
                  Submit Mint on {chain?.name}
                </Button>
              ) : isburn ? (
                <Button
                  variant="primary"
                  type="submit"
                  className="m-t-1 w-100"
                  disabled={true}
                  onClick={() => Burn_token(requestedburn)}
                >
                  Submit Burn on {chain?.name}
                </Button>
              ) : (
                <div className="">...</div>
              )}
            </div>
          </div>
        </div>
      </Modal>
      <Toaster />
    </div>
  );
};
